import { Auth0Client } from '@auth0/auth0-spa-js';

import authConfig from '../config/authConfig';

export const auth0Client = new Auth0Client({
  domain: authConfig.domain!,
  client_id: authConfig.clientID!,
  redirect_uri: window.location.origin,
  audience: authConfig.audience,
  scope: authConfig.scope,
  cacheLocation: 'localstorage',
  //useRefreshTokens: true,
});
